<template>
  <div class="bk-form-item">
    <slot />
  </div>
</template>
